import React from 'react';
import ImageBanner from './image-banner';
import '../css/split-image.less';

export default ({data, header, isMobile}) => {

    return(
        <div className='custom-component split-image'>
            <h1 className='split-image-header'>{ header }</h1>
        {
            data.map((element, i)=>{
                const { description={}, desktopImageUrl, mobileImageUrl } = element;
                return(
                    <div className='split-item' key={`split-item-${i}`}>
                        <ImageBanner desktopImageUrl={desktopImageUrl} mobileImageUrl={mobileImageUrl} isMobile={isMobile}/>
                        <div className='split-item-text'>
                            <h3>{description.subHeader}</h3>
                            <p>{description.text}</p>
                        </div>
                    </div>
                )
            })
        }
        </div>
    )
}
